// src/composables/useToaster.ts
import { useToast } from 'vue-toast-notification';
import { Lang } from '@/types/general.type';
import servertranslate from '@/utils/servertranslate';

export function useToaster() {
  const toast = useToast();

  const successToaster = (msg: Lang, opt?: Record<string, unknown>) => {
    toast.success(servertranslate(msg), { position: 'bottom-left', ...opt });
  };

  const warningToaster = (msg: Lang, opt?: Record<string, unknown>) => {
    toast.warning(servertranslate(msg), { position: 'bottom-left', ...opt });
  };

  const errorToaster = (msg: Lang, opt?: Record<string, unknown>) => {
    const errormsg = typeof msg === 'object' ? servertranslate(msg) : msg;
    toast.error(errormsg, { position: 'bottom-left', ...opt });
  };

  const infoToaster = (msg: Lang, opt?: Record<string, unknown>) => {
    const infoMsg = typeof msg === 'object' ? servertranslate(msg) : msg;
    toast.info(infoMsg, { position: 'bottom-left', ...opt });
  };

  const defaultToaster = (msg: Lang, opt?: Record<string, unknown>) => {
    const infoMsg = typeof msg === 'object' ? servertranslate(msg) : msg;
    toast.info(infoMsg, { position: 'bottom-left', type: 'default', ...opt });
  };

  return {
    successToaster,
    warningToaster,
    errorToaster,
    infoToaster,
    defaultToaster,
  };
}
